export default "__VITE_ASSET__cBEcDPoO__"